import { render, staticRenderFns } from "./DatatableFilter.vue?vue&type=template&id=2006277a&"
import script from "./DatatableFilter.vue?vue&type=script&lang=js&"
export * from "./DatatableFilter.vue?vue&type=script&lang=js&"
import style0 from "./DatatableFilter.vue?vue&type=style&index=0&id=2006277a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports